import { forwardRef } from "react";
import { useLocation } from "react-router-dom";

const ProfileMenu = forwardRef(
  ({ user, onClose, handleLogout, showOnlyMine, setShowOnlyMine, 
  isLoggingOut,
  setIsLoggingOut, isLoggedIn, setIsLoggedIn}, ref) => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
      <div
        ref={ref}
        className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border"
      >
        <div className="py-1">
          {currentPath === "/fit" && typeof showOnlyMine !== "undefined" && (
            <div className="px-4 py-2 flex items-center justify-between text-sm text-gray-700">
              <span>Only Mine</span>
              <button
                onClick={() => setShowOnlyMine((prev) => !prev)}
                className={`w-10 h-5 flex items-center rounded-full p-1 transition-colors duration-300 ${showOnlyMine ? "bg-blue-600" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${showOnlyMine ? "translate-x-5" : "translate-x-0"
                    }`}
                />
              </button>
            </div>
          )}
          {currentPath !== "/" && (
            <a
              href="/"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={onClose}
            >
              Home
            </a>
          )}
          <a
            href="/profile"
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            onClick={onClose}
          >
            Profile
          </a>
          <a
            href="/settings"
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            onClick={onClose}
          >
            Settings
          </a>
          <button
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t"
            onClick={() => {
              handleLogout();
              onClose();
            }}
          >
            Logout
          </button>
        </div>
      </div>
    );
  }
);

export default ProfileMenu;